<template>
  <paper
    title="General Settings"
    body-class="mt-0"
  >
    <div class="px-2 text-break">
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <input-field
            name="job_template-name"
            label="Name*"
            label-position="top"
          >
            <div>
              {{ jobTemplate.name }}
            </div>
          </input-field>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <input-field
            name="job_template-liveJobTemplate"
            label="Live Job Template"
            label-position="top"
          >
            {{ jobTemplate.liveJobTemplate ? 'Yes' : 'No' }}
          </input-field>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <input-field
            name="job_template-category"
            label="Category"
            label-position="top"
          >
            {{ jobTemplate.category || '-' }}
          </input-field>
        </b-col>
        <b-col
          cols="12"
          sm="6"
        >
          <input-field
            name="job_template-description"
            label="Description"
            label-position="top"
          >
            {{ jobTemplate.description || '-' }}
          </input-field>
        </b-col>
      </b-row>
    </div>
  </paper>
</template>

<script>
import Paper from '@/components/paper/Paper.vue'
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'JobGeneralSettings',
  components: {
    Paper,
    InputField,
  },
  props: {
    jobTemplate: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      generalInformation: {
        name: '',
        category: '',
        description: '',
      },
    }
  },
  methods: {
    openInfo(e) {
      this.$emit('openInfo', e)
    },
  },
}
</script>

<style></style>
